import { BaseService } from '@services/BaseService'

const resource = 'hr/socialhistory'

class SocialHistoryService extends BaseService {
  constructor() {
    super(resource)
  }
}

export const socialHistoryService = new SocialHistoryService()
